// eslint-disable-next-line no-promise-executor-return
export const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
